export default {
  overview: "Aperçu",
  auth: {
    signInBadge: "Espace sécurisé",
    signInTitle: "Connexion",
    signInSubtitle: "Utilisez votre adresse professionnelle pour continuer.",
    signInHint: "Besoin d'un accès ? Contactez votre administrateur.",
  },
  apiKeys: {
    title: "Clés API",
    description: "Générez et gérez les clés qui permettent à vos outils d'accéder à l'API Alkana.",
    createNew: "Nouvelle clé API",
    createDialogTitle: "Créer une clé API",
    createDialogDescription: "Donnez un nom clair pour savoir rapidement où la clé est utilisée.",
    createDialogFirstKey: "Une clé par défaut sera créée automatiquement pour votre espace.",
    nameLabel: "Nom de la clé",
    namePlaceholder: "ex. Production",
    create: "Créer la clé",
    creating: "Création...",
    success: "Succès",
    error: "Une erreur est survenue",
    enterKeyName: "Veuillez saisir un nom de clé API",
    keyCreated: "Clé API créée",
    keyDeleted: "Clé API supprimée",
    keyRegenerated: "Clé API régénérée",
    copyKey: "Copier la clé API",
    showKey: "Afficher la clé complète",
    hideKey: "Masquer la clé",
    copied: "Copié",
    keyCopied: "Clé copiée dans le presse-papiers",
    noKeys: "Aucune clé API pour le moment",
    noKeysDescription: "Créez votre première clé pour commencer à utiliser l'API.",
    activeKeysCaption: "Clés API actives",
    tableHeaders: {
      name: "Nom",
      createdAt: "Créée le",
      lastUsed: "Dernière utilisation",
      actions: "Actions",
    },
    defaultKey: "Par défaut",
    unused: "Jamais utilisée",
    regenerate: "Régénérer",
    regenerating: "Régénération...",
    cancel: "Annuler",
    regenerateConfirmTitle: "Régénérer la clé API ?",
    regenerateConfirmDescription:
      "L'ancienne clé cessera immédiatement de fonctionner et ne pourra pas être récupérée.",
    keyCreatedTitle: "Enregistrez cette clé",
    keyCreatedDescription:
      "Vous ne verrez cette valeur qu'une seule fois. Copiez-la dans un endroit sécurisé.",
    keyRegeneratedTitle: "Clé API régénérée",
    keyRegeneratedDescription:
      "Copiez la nouvelle clé et mettez à jour vos intégrations. L'ancienne n'est plus valide.",
    createError: "Échec de la création de la clé API",
    deleteError: "Échec de la suppression de la clé API",
    fetchError: "Échec du chargement des clés API",
    regenerateError: "Échec de la régénération de la clé API",
  },
} as const;
